import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-509d71bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ProfileEdit grid padded footer-white-after" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "debug",
  "data-scroll-section": ""
}, null, -1))
const _hoisted_3 = { class: "ProfileEdit__Inner" }
const _hoisted_4 = {
  class: "ProfileEdit__Form__Top",
  "data-scroll-section": ""
}
const _hoisted_5 = { class: "ProfileEdit__Header__Inner" }
const _hoisted_6 = { class: "ProfileEdit__Header__Title h1 h1--edit" }
const _hoisted_7 = { class: "margin-small" }
const _hoisted_8 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_9 = { class: "fieldset__row fieldset__row--4" }
const _hoisted_10 = { class: "margin-small" }
const _hoisted_11 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_12 = { class: "margin-small" }
const _hoisted_13 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_14 = { class: "margin-small" }
const _hoisted_15 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_16 = { class: "margin-small" }
const _hoisted_17 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_18 = { class: "ProfileEdit__Form__AboutMe" }
const _hoisted_19 = ["rows"]
const _hoisted_20 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_21 = {
  class: "ProfileEdit__Form__Experience",
  "data-scroll-section": ""
}
const _hoisted_22 = { class: "ProfileEdit__Form__Section__Title" }
const _hoisted_23 = {
  class: "ProfileEdit__Form__Questions",
  "data-scroll-section": ""
}
const _hoisted_24 = { class: "ProfileEdit__Form__Section__Title" }
const _hoisted_25 = { class: "ProfileEdit__Form__Section__Inner" }
const _hoisted_26 = ["onUpdate:modelValue"]
const _hoisted_27 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_28 = { "data-scroll-section": "" }
const _hoisted_29 = { class: "form__submit" }
const _hoisted_30 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_31 = {
  key: 0,
  class: "error-msg error-msg--alt t-list"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LineByLine = _resolveComponent("LineByLine")!
  const _component_AppearObject = _resolveComponent("AppearObject")!
  const _component_FieldsetAvatar = _resolveComponent("FieldsetAvatar")!
  const _component_FieldsetPreferences = _resolveComponent("FieldsetPreferences")!
  const _component_FieldsetExperiences = _resolveComponent("FieldsetExperiences")!
  const _component_ButtonSave = _resolveComponent("ButtonSave")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ErrorPopin = _resolveComponent("ErrorPopin")!
  const _component_LeavePopin = _resolveComponent("LeavePopin")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("form", {
        class: "ProfileEdit__Form form",
        onSubmit: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
        novalidate: ""
      }, [
        _createElementVNode("section", _hoisted_4, [
          _createVNode(_component_AppearObject, { class: "ProfileEdit__Header" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h1", _hoisted_6, [
                  _createElementVNode("span", null, [
                    _createVNode(_component_LineByLine, {
                      innerHTML: _ctx.$t('profileEdit.title1')
                    }, null, 8, ["innerHTML"])
                  ]),
                  _createVNode(_component_LineByLine, {
                    innerHTML: _ctx.$t('profileEdit.title2')
                  }, null, 8, ["innerHTML"])
                ]),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('profileEdit.instruction')), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_FieldsetAvatar, {
            class: "ProfileEdit__Avatar",
            onChange: _ctx.onAvatarChange
          }, null, 8, ["onChange"]),
          _createElementVNode("fieldset", _hoisted_7, [
            _createElementVNode("legend", null, _toDisplayString(_ctx.$t('profileEdit.surname')), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.surname) = $event)),
              onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$?.form.surname?.$touch && _ctx.v$?.form.surname?.$touch(...args))),
              class: _normalizeClass({ 'error': _ctx.v$?.form.surname?.$errors.length }),
              type: "text",
              name: "surname",
              spellcheck: "false",
              autocorrect: "off"
            }, null, 34), [
              [
                _vModelText,
                _ctx.form.surname,
                void 0,
                { trim: true }
              ]
            ]),
            (_ctx.v$?.form.surname?.$errors?.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.v$?.form.surname?.$errors[0]?.$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("fieldset", _hoisted_10, [
              _createElementVNode("legend", null, _toDisplayString(_ctx.$t('profileEdit.facebook')), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.facebook) = $event)),
                onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.v$?.facebook?.$touch && _ctx.v$?.facebook?.$touch(...args))),
                class: _normalizeClass({ 'error': _ctx.v$?.facebook?.$errors.length }),
                type: "text",
                name: "facebook",
                spellcheck: "false",
                autocorrect: "off"
              }, null, 34), [
                [
                  _vModelText,
                  _ctx.form.facebook,
                  void 0,
                  { trim: true }
                ]
              ]),
              (_ctx.v$?.facebook?.$errors?.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.v$?.facebook?.$errors[0]?.$message), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("fieldset", _hoisted_12, [
              _createElementVNode("legend", null, _toDisplayString(_ctx.$t('profileEdit.instagram')), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.instagram) = $event)),
                onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.v$?.instagram?.$touch && _ctx.v$?.instagram?.$touch(...args))),
                class: _normalizeClass({ 'error': _ctx.v$?.instagram?.$errors.length }),
                type: "text",
                name: "instagram",
                spellcheck: "false",
                autocorrect: "off"
              }, null, 34), [
                [
                  _vModelText,
                  _ctx.form.instagram,
                  void 0,
                  { trim: true }
                ]
              ]),
              (_ctx.v$?.instagram?.$errors?.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.v$?.instagram?.$errors[0]?.$message), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("fieldset", _hoisted_14, [
              _createElementVNode("legend", null, _toDisplayString(_ctx.$t('profileEdit.linkedin')), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.linkedin) = $event)),
                onBlur: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.v$?.linkedin?.$touch && _ctx.v$?.linkedin?.$touch(...args))),
                class: _normalizeClass({ 'error': _ctx.v$?.linkedin?.$errors.length }),
                type: "text",
                name: "linkedin",
                spellcheck: "false",
                autocorrect: "off"
              }, null, 34), [
                [
                  _vModelText,
                  _ctx.form.linkedin,
                  void 0,
                  { trim: true }
                ]
              ]),
              (_ctx.v$?.linkedin?.$errors?.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.v$?.linkedin?.$errors[0]?.$message), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("fieldset", _hoisted_16, [
              _createElementVNode("legend", null, _toDisplayString(_ctx.$t('profileEdit.tiktok')), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.tiktok) = $event)),
                onBlur: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.v$?.tiktok?.$touch && _ctx.v$?.tiktok?.$touch(...args))),
                class: _normalizeClass({ 'error': _ctx.v$?.tiktok?.$errors.length }),
                type: "text",
                name: "tiktok",
                spellcheck: "false",
                autocorrect: "off"
              }, null, 34), [
                [
                  _vModelText,
                  _ctx.form.tiktok,
                  void 0,
                  { trim: true }
                ]
              ]),
              (_ctx.v$?.tiktok?.$errors?.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.v$?.tiktok?.$errors[0]?.$message), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("fieldset", _hoisted_18, [
            _createElementVNode("legend", null, _toDisplayString(_ctx.$t('profileEdit.aboutMe')), 1),
            _withDirectives(_createElementVNode("textarea", {
              "data-autosize": "",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.aboutMe) = $event)),
              onBlur: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.v$?.form.aboutMe?.$touch && _ctx.v$?.form.aboutMe?.$touch(...args))),
              class: _normalizeClass({ 'error': _ctx.v$?.form.aboutMe?.$errors.length }),
              name: "aboutMe",
              cols: "10",
              rows: _ctx.Viewport.isMobile ? 7 : 2
            }, null, 42, _hoisted_19), [
              [
                _vModelText,
                _ctx.form.aboutMe,
                void 0,
                { trim: true }
              ]
            ]),
            (_ctx.v$?.form.aboutMe?.$errors?.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.v$?.form.aboutMe?.$errors[0]?.$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_FieldsetPreferences, {
            class: "ProfileEdit__Preferences",
            ref: "preferences",
            onChanged: _ctx.hasChanged
          }, null, 8, ["onChanged"])
        ]),
        _createElementVNode("section", _hoisted_21, [
          _createElementVNode("h2", _hoisted_22, _toDisplayString(_ctx.$t('profileEdit.experience')), 1),
          _createVNode(_component_FieldsetExperiences, {
            class: "ProfileEdit__Experiences",
            ref: "experiences",
            onChanged: _ctx.hasChanged
          }, null, 8, ["onChanged"])
        ]),
        _createElementVNode("section", _hoisted_23, [
          _createElementVNode("h2", _hoisted_24, _toDisplayString(_ctx.$t('profileEdit.questions')), 1),
          _createElementVNode("div", _hoisted_25, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.answers, (answer, index) => {
              return (_openBlock(), _createElementBlock("fieldset", {
                key: 'answer-'+index,
                class: "margin-small"
              }, [
                _createElementVNode("legend", null, _toDisplayString(_ctx.$t('profileEdit.question'+(index+1))), 1),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": ($event: any) => ((answer.text) = $event),
                  onBlur: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.v$?.form.answers?.$touch && _ctx.v$?.form.answers?.$touch(...args))),
                  class: _normalizeClass({ 'error': _ctx.v$?.form.answers.$each.$response.$errors[index].text.length }),
                  type: "text",
                  name: "answer",
                  spellcheck: "false",
                  autocorrect: "off"
                }, null, 42, _hoisted_26), [
                  [
                    _vModelText,
                    answer.text,
                    void 0,
                    { trim: true }
                  ]
                ]),
                (_ctx.v$?.form.answers.$each.$response.$errors[index].text.length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(_ctx.v$?.form.answers.$each.$response.$errors[index].text[0].$message), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_ButtonSave, {
              saved: _ctx.saved,
              loading: _ctx.loading,
              type: "submit",
              class: "button button--black"
            }, {
              saved: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('profileEdit.saved')), 1)
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('profileEdit.save')) + " ", 1)
              ]),
              _: 1
            }, 8, ["saved", "loading"]),
            _createVNode(_component_router_link, {
              to: "/my-profile",
              class: "link-cancel"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('profileEdit.backToProfile')), 1)
              ]),
              _: 1
            }),
            (_ctx.errorMessage !== null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ]),
          (_ctx.errors)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_31, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (item, i) => {
                  return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(item), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_ErrorPopin, { active: _ctx.errorRequest }, null, 8, ["active"]),
        _createVNode(_component_LeavePopin, {
          title: _ctx.$t('profileEdit.leaveTitle'),
          text: _ctx.$t('profileEdit.leaveText'),
          labelAccept: _ctx.$t('profileEdit.leaveAccept'),
          labelDecline: _ctx.$t('profileEdit.leaveDecline'),
          active: _ctx.showLeavePopin,
          onOnAccept: _ctx.onLeaveAccept,
          onOnDecline: _ctx.onLeaveDecline
        }, null, 8, ["title", "text", "labelAccept", "labelDecline", "active", "onOnAccept", "onOnDecline"])
      ], 32)
    ])
  ]))
}